const colors = [
  {
    color: '#FFFFFF',
    name: 'blanco',
  },
  {
    color: '#0F0F0F',
    name: 'negro',
  },
  {
    color: '#F8C125',
    name: 'amarillo',
  },
  {
    color: '#3A5CB6',
    name: 'azul',
  },
  {
    color: '#DF5555',
    name: 'rojo',
  },
  {
    color: '#89D184',
    name: 'verde',
  },
  {
    color: '#9349B6',
    name: 'violeta',
  },
  {
    color: '#FF8F45',
    name: 'naranja',
  },
]

export default {
  computed: {
    colors() {
      return colors
    }
  },
  methods: {
    colorNameToHex: name => colors.find(color => color.name === name).color
  }
}